import styled from 'styled-components';

import Hero from '../components/Hero';
import OptimizedInterest from '../components/sections/OptimizedInterest';
import WebApp from '../components/sections/GeniusWebapp';
import FrictionlessAccess from '../components/sections/FrictionlessAccess';
import FirstSteps from '../components/sections/FirstSteps';
import InTheMedia from '../components/sections/InTheMedia';
// import { Scroller, Section } from 'react-fully-scrolled';
import { useEffect } from 'react';
// import Header from '../components/Header';
import Footer from '../components/Footer';

const SectionContainer = styled.div`
    scroll-behavior: smooth;
    scroll-snap-type: y mandatory;

    & > * {
      scroll-snap-align: start;
    }


    /* display: flex;
    justify-content: center;


    & > div {
      max-width: 1200px;
      transition: transform 1.33s cubic-bezier(0.19, 1, 0.22, 1) 0s !important;
    } */
`

function Home({loading, mainVideoRef}) {

  useEffect(() => {
    document.ontouchmove = function(ev) {
      ev.preventDefault();
    }
  }, [])

    return (
      <SectionContainer>
            {/* <Header /> */}
            <Hero loading={loading} mainVideoRef={mainVideoRef} />
            <OptimizedInterest />
            <WebApp />
            <FrictionlessAccess />
            <FirstSteps />
            <InTheMedia />
            <Footer />
      </SectionContainer>
    )

}

export default Home;